import { LevelConfig } from "./types";

export const GAME_CONFIG = {
  SAVE_PROGRESS: false,
  DEFAULT_GRID_SIZE: 5,
  POINTS_CORRECT: 10,
  POINTS_WRONG: -5,
  PREVIEW_OPACITY: 0.95,
};

export const STORAGE_KEY = "memoryMinigameProgress";

export const LEVEL_SETTINGS: Record<number, LevelConfig> = {
  1: {
    gridSize: 4,
    pathLength: 3,
    attempts: 3,
    maxMisses: 1,
    previewDuration: 2000,
  },
  2: {
    gridSize: 4,
    pathLength: 4,
    attempts: 3,
    maxMisses: 2,
    previewDuration: 1800,
  },
  3: {
    gridSize: 4,
    pathLength: 5,
    attempts: 3,
    maxMisses: 3,
    previewDuration: 1700,
  },
  4: {
    gridSize: 5,
    pathLength: 5,
    attempts: 3,
    maxMisses: 3,
    previewDuration: 1600,
  },
  5: {
    gridSize: 5,
    pathLength: 6,
    attempts: 3,
    maxMisses: 3,
    previewDuration: 1500,
  },
  6: {
    gridSize: 5,
    pathLength: 7,
    attempts: 3,
    maxMisses: 4,
    previewDuration: 1400,
  },
  7: {
    gridSize: 6,
    pathLength: 7,
    attempts: 3,
    maxMisses: 4,
    previewDuration: 1400,
  },
  8: {
    gridSize: 6,
    pathLength: 8,
    attempts: 3,
    maxMisses: 4,
    previewDuration: 1300,
  },
  9: {
    gridSize: 6,
    pathLength: 9,
    attempts: 3,
    maxMisses: 5,
    previewDuration: 1200,
  },
  10: {
    gridSize: 7,
    pathLength: 9,
    attempts: 3,
    maxMisses: 5,
    previewDuration: 1100,
  },
  11: {
    gridSize: 7,
    pathLength: 10,
    attempts: 3,
    maxMisses: 5,
    previewDuration: 1000,
  },
  12: {
    gridSize: 7,
    pathLength: 11,
    attempts: 3,
    maxMisses: 6,
    previewDuration: 900,
  },
  13: {
    gridSize: 8,
    pathLength: 11,
    attempts: 3,
    maxMisses: 6,
    previewDuration: 900,
  },
  14: {
    gridSize: 8,
    pathLength: 12,
    attempts: 2,
    maxMisses: 6,
    previewDuration: 800,
  },
  15: {
    gridSize: 8,
    pathLength: 13,
    attempts: 2,
    maxMisses: 7,
    previewDuration: 700,
  },

  // -- added: 30 more progressive levels (16..45) --
  16: {
    gridSize: 9,
    pathLength: 14,
    attempts: 2,
    maxMisses: 7,
    previewDuration: 650,
  },
  17: {
    gridSize: 9,
    pathLength: 15,
    attempts: 2,
    maxMisses: 7,
    previewDuration: 600,
  },
  18: {
    gridSize: 9,
    pathLength: 16,
    attempts: 2,
    maxMisses: 8,
    previewDuration: 550,
  },
  19: {
    gridSize: 10,
    pathLength: 16,
    attempts: 2,
    maxMisses: 8,
    previewDuration: 500,
  },
  20: {
    gridSize: 10,
    pathLength: 17,
    attempts: 2,
    maxMisses: 8,
    previewDuration: 480,
  },
  21: {
    gridSize: 10,
    pathLength: 18,
    attempts: 2,
    maxMisses: 9,
    previewDuration: 460,
  },
  22: {
    gridSize: 10,
    pathLength: 19,
    attempts: 2,
    maxMisses: 9,
    previewDuration: 440,
  },
  23: {
    gridSize: 11,
    pathLength: 19,
    attempts: 2,
    maxMisses: 9,
    previewDuration: 420,
  },
  24: {
    gridSize: 11,
    pathLength: 20,
    attempts: 2,
    maxMisses: 10,
    previewDuration: 400,
  },
  25: {
    gridSize: 11,
    pathLength: 21,
    attempts: 2,
    maxMisses: 10,
    previewDuration: 380,
  },
  26: {
    gridSize: 11,
    pathLength: 22,
    attempts: 1,
    maxMisses: 11,
    previewDuration: 360,
  },
  27: {
    gridSize: 12,
    pathLength: 22,
    attempts: 1,
    maxMisses: 11,
    previewDuration: 340,
  },
  28: {
    gridSize: 12,
    pathLength: 23,
    attempts: 1,
    maxMisses: 12,
    previewDuration: 320,
  },
  29: {
    gridSize: 12,
    pathLength: 24,
    attempts: 1,
    maxMisses: 12,
    previewDuration: 300,
  },
  30: {
    gridSize: 12,
    pathLength: 25,
    attempts: 1,
    maxMisses: 12,
    previewDuration: 280,
  },
  31: {
    gridSize: 13,
    pathLength: 25,
    attempts: 1,
    maxMisses: 13,
    previewDuration: 260,
  },
  32: {
    gridSize: 13,
    pathLength: 26,
    attempts: 1,
    maxMisses: 13,
    previewDuration: 240,
  },
  33: {
    gridSize: 13,
    pathLength: 27,
    attempts: 1,
    maxMisses: 13,
    previewDuration: 220,
  },
  34: {
    gridSize: 13,
    pathLength: 28,
    attempts: 1,
    maxMisses: 14,
    previewDuration: 200,
  },
  35: {
    gridSize: 14,
    pathLength: 28,
    attempts: 1,
    maxMisses: 14,
    previewDuration: 190,
  },
  36: {
    gridSize: 14,
    pathLength: 29,
    attempts: 1,
    maxMisses: 14,
    previewDuration: 180,
  },
  37: {
    gridSize: 14,
    pathLength: 30,
    attempts: 1,
    maxMisses: 15,
    previewDuration: 170,
  },
  38: {
    gridSize: 14,
    pathLength: 31,
    attempts: 1,
    maxMisses: 15,
    previewDuration: 160,
  },
  39: {
    gridSize: 15,
    pathLength: 31,
    attempts: 1,
    maxMisses: 15,
    previewDuration: 150,
  },
  40: {
    gridSize: 15,
    pathLength: 32,
    attempts: 1,
    maxMisses: 16,
    previewDuration: 140,
  },
  41: {
    gridSize: 15,
    pathLength: 33,
    attempts: 1,
    maxMisses: 16,
    previewDuration: 130,
  },
  42: {
    gridSize: 16,
    pathLength: 33,
    attempts: 1,
    maxMisses: 16,
    previewDuration: 120,
  },
  43: {
    gridSize: 16,
    pathLength: 34,
    attempts: 1,
    maxMisses: 17,
    previewDuration: 110,
  },
  44: {
    gridSize: 16,
    pathLength: 35,
    attempts: 1,
    maxMisses: 17,
    previewDuration: 100,
  },
  45: {
    gridSize: 16,
    pathLength: 36,
    attempts: 1,
    maxMisses: 18,
    previewDuration: 90,
  },
};
